import { Box, Flex } from '@rebass/grid';
import TimePeriodPicker from 'components/TimePeriodPicker';
import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Action, ActionFunction2 } from 'redux-actions';
import { Coin } from 'store/Coin/types';
import { ChartDataPoint } from 'store/Market/Chart/types';

import Chart from './Chart';
import withContainer from './container';
import { Container, ExchangeLabel, GlobeImage, Pair } from './styles';

interface Props {
  coin: Coin;
  fetchChart: ActionFunction2<
    string,
    string,
    Action<{ coinId: string; period: string }>
  >;
  chartData: ChartDataPoint[];
}

const MarketCharts = (props: Props) => {
  const { fetchChart, chartData, coin } = props;
  const { t } = useTranslation();
  const ref = useRef(null);

  const [selectedPeriod, setSelectedPeriod] = useState('1D');

  useEffect(() => {
    fetchChart(coin.id, selectedPeriod);
  }, [selectedPeriod, coin.id, fetchChart]);

  const formattedData = chartData.map((dataPoint: any) => {
    return {
      date: dataPoint.timestamp * 1000,
      price: dataPoint.close,
      volume: dataPoint.volume,
    };
  });

  if (formattedData.length === 0) {
    return null;
  }

  return (
    <Container ref={ref}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        pb="26px"
        flexDirection={['column', 'row']}
      >
        <Flex mb={['20px', 0]}>
          <GlobeImage src="/static/images/icons/globe.svg" />
          <ExchangeLabel>
            {t('assets.detail.charts.global-average')}{' '}
            <Pair>{coin.code}/USD</Pair>
          </ExchangeLabel>
        </Flex>

        <Box>
          <TimePeriodPicker
            periods={['1H', '1D', '1W', '1M', '6M', '1Y', 'ALL']}
            selectedPeriod={selectedPeriod}
            onChange={setSelectedPeriod}
          />
        </Box>
      </Flex>
      <Chart data={formattedData} coin={coin} />
    </Container>
  );
};

export default withContainer<{ coin: Coin }>(MarketCharts);
